import React from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // Log to console + could POST to /api/telemetry when we add it
    console.error('React ErrorBoundary caught', error, info);
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (this.state.hasError) {
      return (
        <div className="page-container" data-testid="error-boundary">
          <h1 className="page-title">Something went wrong.</h1>
          <p className="muted" style={{ marginBottom: 16 }}>
            The page hit an error. You can try again, or go home.
          </p>
          <details className="error-details" style={{ marginBottom: 20 }}>
            <summary>Error details</summary>
            <pre style={{ background: 'var(--surface)', padding: 12, borderRadius: 8, overflowX: 'auto', fontSize: 12 }}>
              {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
            </pre>
          </details>
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="pill-btn" onClick={this.reset} type="button">Try again</button>
            <Link className="pill-btn primary" to="/">Go home</Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
